// extracted by mini-css-extract-plugin
export default {"wrapper":"Iu-z","response":"Ju-z","error":"Ku-z","disabled":"Lu-z","buttons":"Mu-z","feedbackQuestionSection":"Nu-z","yesNoWrapper":"Ou-z"};